import { BASE_DOC_URL } from 'trtc-js-sdk-core';
/**
 * 静态方法保护装饰器
 * 当静态方法被从实例上误访问时，打印警告日志并返回 undefined
 *
 * @example
 * class TRTC {
 *   @warnOnInstanceAccess()
 *   static setLogLevel(level: number) {
 *     // 静态方法实现
 *   }
 * }
 *
 * const instance = new TRTC();
 * instance.setLogLevel(1); // 会打印警告并返回 undefined
 * TRTC.setLogLevel(1);     // 正常调用
 */
export function warnOnInstanceAccess() {
  return function (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    // 在原型上添加一个同名方法，用于拦截实例访问
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-param-reassign
    target.prototype[propertyKey] = function () {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const logger = (this as any)._log || console;

      const message = `"${propertyKey}" is a static method. Use TRTC.${propertyKey}() instead. ` +
        `See: ${BASE_DOC_URL}/en/TRTC.html#.${propertyKey}`;

      logger.warn(message);

      // 仅警告，不执行静态方法
      return;
    };

    // 保持原有的静态方法不变
    return descriptor;
  };
}

